import type { HttpTransport } from "@common/api/transport";
import type { ID } from "@common/types/api";
import type { CropValue } from "@common/types/CropValue";
import type { CurrencyPreference } from "@common/types/User";

export type CropValuesParams =
  | { cropId?: number | null; gardenCropId?: never }
  | { cropId?: never; gardenCropId?: ID | null };

export const createCropValuesApi = (http: HttpTransport) => ({
  createCropValue: (params: {
    cropId: number;
    valuePerGram: number;
    currency: CurrencyPreference;
  }) => http.post<CropValue>("/api/crop_values", { cropValue: params }),

  fetchCropValues: (params?: CropValuesParams) =>
    http.get<{ items: CropValue[] }>("/api/crop_values", {
      queryParams: params ?? {}
    })
});
